const BECOME_CREATOR_STATUSES = {
  PENDING: 'pending',
  DECLINED: 'declined',
  APPROVED: 'approved',
  // Only front end status, we set it when request hasn't been made yet.
  INITIAL: 'initial',
};

export default BECOME_CREATOR_STATUSES;
